/**
 * embroidery-input.js
 * 名入れオーダー用テキスト入力バリデーション
 * - 英字のみ（A-Z / a-z）
 * - 5文字以内
 * - リアルタイム文字カウンター
 * - エラー時はカートに追加ボタンをグレーアウト
 * - 未入力のままカート追加 → 「Happy」をデフォルト値としてセット
 * - 日本語IME変換中の誤送信を防止（compositionstart/compositionend対応）
 */
(function () {
  'use strict';

  const MAX_CHARS = 5;
  const ALPHA_ONLY = /^[a-zA-Z]*$/;
  const DEFAULT_VALUE = 'Happy';

  function initEmbroideryInput(wrapper) {
    const input = wrapper.querySelector('[data-embroidery-input]');
    const counter = wrapper.querySelector('[data-embroidery-counter]');
    const errorEl = wrapper.querySelector('[data-embroidery-error]');

    if (!input) return;

    // このinputが属するフォームを取得
    const form = input.closest('[data-type="add-to-cart-form"]');
    if (!form) return;

    // カートに追加ボタンを取得（在庫なしで既にdisabledの場合は触らない）
    const submitBtn = form.querySelector('button[name="add"]');
    if (!submitBtn) return;

    // 商品在庫なし・購入不可の場合はdisabled状態を保持するフラグ
    const isSoldOut = submitBtn.disabled;

    // 日本語IME変換中フラグ（変換中はボタン無効・送信ブロック）
    let isComposing = false;

    /**
     * バリデーション実行
     * @returns {string} エラーメッセージ（エラーなしなら空文字）
     */
    function getError(value) {
      if (value.length === 0) return ''; // 未入力はOK（submit時にデフォルト値をセット）
      if (!ALPHA_ONLY.test(value)) return '英字のみ入力できます（A〜Z / a〜z）';
      if (value.length > MAX_CHARS) return `5文字以内で入力してください（現在${value.length}文字）`;
      return '';
    }

    /**
     * UIを更新する
     */
    function updateUI() {
      const value = input.value;
      const len = value.length;
      const errorMsg = getError(value);
      const hasError = errorMsg !== '';

      // 文字カウンター
      if (counter) {
        counter.textContent = `${len}/5文字`;
        counter.classList.toggle('embroidery-input__counter--over', len > MAX_CHARS);
      }

      // エラーメッセージ
      if (errorEl) {
        errorEl.textContent = errorMsg;
        errorEl.hidden = !hasError;
      }

      // ラッパーにエラークラス（inputのボーダー色変更）
      wrapper.classList.toggle('embroidery-input__wrapper--error', hasError);

      // カートに追加ボタンの制御（在庫なしの場合は変更しない）
      // IME変換中も無効化する
      if (!isSoldOut) {
        submitBtn.disabled = hasError || isComposing;
        submitBtn.classList.toggle('embroidery-btn--error-state', hasError || isComposing);
      }
    }

    // IME変換開始：変換確定前はボタンを無効化する
    input.addEventListener('compositionstart', function () {
      isComposing = true;
      updateUI();
    });

    // IME変換確定：確定後の値でバリデーションを実行
    input.addEventListener('compositionend', function () {
      isComposing = false;
      updateUI();
    });

    // リアルタイムバリデーション
    input.addEventListener('input', updateUI);

    // フォーム送信前: 未入力ならデフォルト値をセット、エラーがあれば送信キャンセル
    form.addEventListener(
      'submit',
      function (event) {
        // IME変換中は送信をブロック
        if (isComposing) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        const value = input.value.trim();
        const errorMsg = getError(value);

        if (errorMsg) {
          // バリデーションエラーのまま送信されようとした場合に停止
          event.preventDefault();
          event.stopImmediatePropagation();
          updateUI();
          input.focus();
          return;
        }

        if (value === '') {
          input.value = DEFAULT_VALUE;
        }
      },
      { capture: true }
    );

    // 初期状態を反映
    updateUI();
  }

  function init() {
    document.querySelectorAll('[data-embroidery-wrapper]').forEach(initEmbroideryInput);
  }

  // DOMContentLoaded 前後どちらでも動作する
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
